var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-round"},[(_vm.type === 'multi-channel')?_c('a-icon',{staticClass:"icon-round--multichannel",attrs:{"type":"message","theme":"filled"}}):_c('social-icon',{attrs:{"type":_vm.type,"size":19}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }